export const testIds = Object.freeze({
  LoginBtn: 'LoginBtn',
  gnb: {
    GnbNav: 'GnbNav',
    NavChildren: 'NavChildren',
  },
  footer: {
    Footer: 'Footer',
  },
  SummaryCard: {
    NextStepButton: 'NextStepButton',
  },
  TryoutsTable: {
    TBody: 'TBody',
    Row: 'TryoutsTableRow',
  },
  TryoutsViewChanger: {
    calendar: 'TryoutsViewChanger.calendar',
    table: 'TryoutsViewChanger.table',
  },
  TestToolbar: {
    ClassificationCode: 'ClassificationCode',
    Site: 'Site',
  },
  Calendar: {
    Head: {
      MonthChangerNext: 'MonthChangerNext',
      MonthChangerPrev: 'MonthChangerPrev',
      MonthChangerToday: 'MonthChangerToday',
      YearMonthTxt: 'YearMonthTxt',
      MonthSelectorNext: 'MonthSelectorNext',
      MonthSelectorPrev: 'MonthSelectorPrev',
      MonthSelectorYear: 'MonthSelectorYear',
      MonthSelectorMonthsList: 'MonthSelectorMonthsList',
    },
  },
  tryouts: {
    apply: {
      select: {
        programmingLanguageOption: 'programmingLanguageOption',
      },
    },
  },
  admin: {
    CodeSelector: {
      PlaceSelectorBody: 'PlaceSelectorBody',
    },
  },
  profile: {
    Name: 'ProfileName',
    Email: 'ProfileEmail',
    Phone: 'ProfilePhone',
    BirthDate: 'ProfileBirthDate',
    AchievementsTable: 'ProfileAchievementsTable',
  },
  main: {
    Tryouts: {
      Banners: 'MainTryoutsBanners',
    },
  },
  jobs: {
    JobsList: {
      Item: 'JobsListItem',
    },
    JobDetail: {
      Title: 'JobDetailTitle',
    },
  },
  UniversityUseCases: {
    List: {
      Article: 'UniversityUseCasesListArticle',
    },
  },
  EnterpriseUseCases: {
    List: {
      Article: 'EnterpriseUseCasesListArticle',
    },
  },
});
